import { Vue, Component, Prop } from 'vue-property-decorator'
import loc from '~/utils/loc'
import NotFountSvg from '~/assets/svg/basket-not-fount.svg?inline'

@Component
export default class BasketNotFoundPage extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly hideTitle?: boolean

  @Prop({ type: Boolean, default: false })
  readonly paddingTop?: boolean

  render () {
    return (
      <div class="basket-not-found-page">
        <div class={{
          'basket-not-found-page__info-block': true,
          'basket-not-found-page__info-block_padding-top': this.paddingTop
        }}>
          <div class="basket-not-found-page__content">
            <div class="basket-not-found-page__info-row">
              <div class="basket-not-found-page__info">
                {
                  !this.hideTitle
                    ? <div class="basket-not-found-page__title"> Корзина пуста </div>
                    : ''
                }
                <div class="basket-not-found-page__description">
                  Посмотрите предложения на главной странице, воспользуйтесь каталогом или поиском
                </div>
                <div class="basket-not-found-page__btn">
                  <nuxt-link to={loc(this.$store, { name: 'catalog' })} class="button-text">
                    В каталог
                  </nuxt-link>
                </div>
              </div>
              <div class="basket-not-found-page__image">
                <NotFountSvg />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
